import Button from 'components/ReusableComponents/Button'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from './GXPLogin.module.scss'
import { useGXPLogin } from './GXPLoginContext'

export default function UserGettingRegionalAccessStep() {
  const { setActiveStep, pushToData } = useGXPLogin()
  const [loading, setLoading] = useState(false)
  const { addToast, removeToast } = useToasts()

  const onClickCheck = async () => {
    setLoading(true)
    const toastId = addToast('Checking', {
      appearance: 'info',
      autoDismiss: false
    })
    await pmsApi.checkMarriotEmailConfirmation()

    removeToast(toastId)
    addToast('Checked successfully', {
      appearance: 'success',
      autoDismiss: true
    })
    const res = await pmsApi.updateMarriotGxpConfig({
      activeStep: 'Completed'
    })
    pushToData(res)
    setLoading(false)
    setActiveStep('Completed')
  }

  return (
    <div>
      <div className={styles.cardTitle}>Pending email confirmation from Marriott.</div>
      <div className={styles.cardText}>
        When we receive the email, this step will be automatically skipped. You can also
        check manually by clicking on the button below.
      </div>

      <div className={styles.actions}>
        <Button type="secondary" onClick={onClickCheck} disabled={loading}>
          Check manually
        </Button>
      </div>
    </div>
  )
}
